/** Matches the backend default page size of `GET /hotels/:hotelId/partners/services`. */
export const GUESTERIA_SERVICES_PAGE_SIZE = 20;

/** Number of pages for `total` items; at least 1 so an empty list keeps a valid page. */
export function getTotalPages(
  total: number | undefined,
  pageSize: number,
): number {
  if (
    total === undefined ||
    !Number.isFinite(total) ||
    total <= 0 ||
    !Number.isFinite(pageSize) ||
    pageSize <= 0
  ) {
    return 1;
  }
  return Math.ceil(total / pageSize);
}

/** Restricts `page` to the range 1..totalPages; non-numeric input becomes 1. */
export function clampPage(page: number, totalPages: number): number {
  if (!Number.isFinite(page)) {
    return 1;
  }
  return Math.min(Math.max(1, Math.trunc(page)), Math.max(1, totalPages));
}

export function paginateRows<T>(
  rows: readonly T[],
  page: number,
  pageSize: number,
): T[] {
  const size = Math.floor(pageSize);
  if (!Number.isFinite(size) || size <= 0) {
    return [...rows];
  }
  const current = clampPage(page, getTotalPages(rows.length, size));
  return rows.slice((current - 1) * size, current * size);
}

export type PaginationState = {
  page: number;
  conditionsKey: string;
};

export function syncPaginationState(
  state: PaginationState,
  conditionsKey: string,
  totalPages: number,
): PaginationState {
  if (state.conditionsKey !== conditionsKey) {
    return { page: 1, conditionsKey };
  }
  const page = clampPage(state.page, totalPages);
  return page === state.page ? state : { page, conditionsKey };
}
